import { Flex, Progress, Typography } from "antd";
import { observer } from "mobx-react-lite";
import React from "react";

interface Props {
  total: number;
  actualTotal: number;
}

export const TotalHeader = observer(({ total, actualTotal }: Props) => {
  const percent = total > 0 ? Math.round((actualTotal / total) * 100) : 0;
  const status = actualTotal > total ? "exception" : percent === 100 ? "success" : "active";

  const fmt = (n: number) => n.toFixed(2).replace(".", ",");

  return (
    <div
      style={{
        position: "sticky",
        top: 0,
        zIndex: 100,
        background: "#fff",
        borderBottom: "2px solid #f0f0f0",
        padding: "8px 24px",
        display: "flex",
        alignItems: "center",
        gap: 24,
        boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
      }}
    >
      {total > 0 && (
        <div style={{ flex: 1 }}>
          <Progress
            size="small"
            percent={percent}
            status={status}
            format={() => `${fmt(actualTotal)} € / ${fmt(total)} €`}
          />
        </div>
      )}
      <Flex vertical align="flex-end">
        <Typography.Title level={4} style={{ margin: 0, whiteSpace: "nowrap" }}>
          Geschätzte Kosten: <span style={{color: "blue"}}>{fmt(total)} €</span>
        </Typography.Title>
        <Typography.Title level={4} style={{ margin: 0, whiteSpace: "nowrap" }}>
          Ist-Kosten: <span style={{color: "red"}}>{fmt(actualTotal)} €</span>
          </Typography.Title>
      </Flex>
    </div>
  );
});
